import { toast } from 'react-toastify';

import { FALLBACK_ERROR_MESSAGE } from '@/helpers/constants/messages';
import { isExpectedError } from '@/helpers/utils/errorHelpers';
import { ResponseError } from '@/types/Error';
import { Action, isRejectedWithValue } from '@reduxjs/toolkit';

import type { Middleware, MiddlewareAPI } from '@reduxjs/toolkit';

export const rtkQueryErrorLogger: Middleware = (api: MiddlewareAPI) => next => (action: Action) => {
  if (isRejectedWithValue(action) && typeof window !== 'undefined') {
    if (!navigator.onLine) {
      toast('Network error', { type: 'error', toastId: 'Network error' });
    } else {
      const error = action.payload as ResponseError;
      const message = error?.data?.message ?? error?.data?.title ?? error.error ?? FALLBACK_ERROR_MESSAGE;

      if (!isExpectedError(error)) {
        toast(message, { type: 'error', toastId: message });
      }
    }
  }

  return next(action);
};
